import React from 'react';
import { useAuth } from './context/AuthProvider';
import { Routes, Route, Navigate } from 'react-router-dom';

// COMPONENTES PARA RUTAS
import Login from './pages/login/Login';
import Dashboard from './pages/dashboard/Dashboard';

// LOVES
import LovesStops from './pages/loves/Loves_Stops';
import Reporte_Loves from './pages/loves/Reporte_Loves';

//Precios
import Precios from './pages/fuel_report/Precios';

//OMNITRACS
import Omni_Subir from './pages/fuel_report/Omni_Subir';
import Omni_Ver from './pages/fuel_report/Omni_Ver';
import Omni_Detalle from './pages/fuel_report/Omni_Detalle';
//Metas
import Metas from './pages/fuel_report/Metas';
//Cargas Fuel Up V2
import CargasColombia from './pages/fuel_report/CargasColombia';
import CargasMonterrey from './pages/fuel_report/CargasMonterrey';
import AgregarColombia from './pages/fuel_report/AgregarCarga';
import Master_Dashboard2 from './pages/fuel_report/Master_Dashboard_tractores';
import Master_Dashboard_Tractores from './pages/fuel_report/Master_Dashboard_tractores';
import Master_Dashboard_Cajas from './pages/fuel_report/Master_Dashboard_cajas';

import CargasArguin from './pages/fuel_report/CargasArguin';
import CargasLoves from './pages/fuel_report/CargasLoves';
import CargasOxxo from './pages/fuel_report/CargasOxxo';

import Kpi from './pages/fuel_report/kpi_main';
import KpiDriver from './pages/fuel_report/kpi_driver';
import KpiAsset from './pages/fuel_report/kpi_asset';
import KpiIdle from './pages/fuel_report/kpi_idle';

import DailyFuelPrice from './pages/Diesel/daily_fuel_price/DailyFuelPrice';

import TankDashboard from './pages/fuel_report/TankDashboard';

import CargasGasoMax from './pages/fuel_report/CargasGasoMax';

import DefCargas from './pages/fuel_report/DefCargas';

import ComprasDiesel from './pages/fuel_report/Compras';

import ComprasDef from './pages/fuel_report/DefCompras';

import CargasFuelAmerica from './pages/fuel_report/CargasFuelAmerica';

import SamsaraRendimiento from './pages/fuel_report/SamsaraRendimiento';
import SamsaraResets from './pages/fuel_report/SamsaraResets';

import FscPrueba from './pages/fuel_report/FscPrueba';

const Main = () => {

    const { isLoggedIn } = useAuth();

    const canAccess = isLoggedIn || window.location.hostname === 'localhost';

    return (

        <div className="App">

            <div 
                style={{ 
                    backgroundColor: '#f2f4f4', 
                    width: '100vw', 
                    minHeight: '100vh',
                    height: 'auto',
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >

                {/* VALIDAMOS SI ESTA LOGUEADO PARA MOSTRAR EL SIDEBAR */}

                {/* {
                    isLoggedIn && ( <MainSideBar/> )
                } */}

{/*                 <div 
                    style={{ 
                        flex: 1, 
                        padding: '0px',
                        marginTop: '0px',
                        overflow: 'auto'
                    }}
                > */}
                <div 
                    style={{ 
                        flex: 1,
                        overflowY: 'auto', // 👈 SCROLL VERTICAL
                        WebkitOverflowScrolling: 'touch' // 👈 iOS smooth
                    }}
                >

                    {/* RUTEO PARA PAGINAS */}

                    <Routes>

                        {/* VALIDAR LOGIN */}
                        <Route 
                            path='/' 
                            element={isLoggedIn ? ( <Dashboard/> ) : (
                                window.location.hostname === 'localhost'
                                ? <Dashboard/>
                                : <Dashboard/>
                            )}
                        /> 
{/*                         <Route 
                            path='/' 
                            element={isLoggedIn ? <Login /> : <Navigate to="https://ebtapps.com/" replace />}
                        /> */}
                        {/* DASHBOARD */}
                        <Route 
                            path='/dashboard' 
                            element={isLoggedIn ? ( <Dashboard/> ): (
                                window.location.hostname === 'localhost'
                                ? <Dashboard/>
                                : <Dashboard/>
                            )}
                        />

                        {/* ----------------------------------------------------------- */}

                        {/* LOVES STOPS */}
                        <Route 
                            path='/diesel/stops' 
                            element={canAccess ? <LovesStops/> : <Navigate to="/" />}
                        />

                        {/* REPORTE DE LOVES */}
                        <Route 
                            path='/diesel/reporteLoves' 
                            element={canAccess ? <Reporte_Loves/> : <Navigate to="/" />}
                        />

                        {/* PRECIOS */}
                        <Route 
                            path='/diesel/precios' 
                            element={canAccess ? <Precios/> : <Navigate to="/" />}
                        />
                        {/* OMNITRACS SUBIR */}
{/*                         <Route 
                            path='/diesel/omni/subir' 
                            element={canAccess ? <Omni_Subir/> : <Navigate to="/" />}
                        /> */}
                        {/* OMNITRACS VER */}
                        <Route 
                            path='/diesel/omni/ver' 
                            element={canAccess ? <Omni_Ver/> : <Navigate to="/" />}
                        />
                        {/* OMNITRACS VER */}
                        <Route 
                            path='/diesel/omni/detalle' 
                            element={canAccess ? <Omni_Detalle/> : <Navigate to="/" />}
                        />

                        {/* Metas */}
                        <Route 
                            path='/diesel/metas' 
                            element={canAccess ? <Metas/> : <Navigate to="/" />}
                        />

                        {/* Master Dashboard - Nuevo Flujo V2 */}
                        <Route 
                            path='/diesel/fuel_up/v2/master_dashboard' 
                            element={canAccess ? <Master_Dashboard2/> : <Navigate to="/"/> }
                        />
                        <Route 
                            path='/diesel/fuel_up/v2/master_dashboard/tractores' 
                            element={canAccess ? <Master_Dashboard_Tractores/> : <Navigate to="/"/> }
                        />
                        <Route 
                            path='/diesel/fuel_up/v2/master_dashboard/cajas' 
                            element={canAccess ? <Master_Dashboard_Cajas/> : <Navigate to="/"/> }
                        />
                        {/* Cargas Fuel Up V2 */}
                        <Route 
                            path='/diesel/fuel_up/v2' 
                            element={canAccess ? <CargasColombia/> : <Navigate to="/" />}
                        />
                        {/* Cargas Fuel Up V2 */}
                        <Route 
                            path='/diesel/fuel_up/v2/2' 
                            element={canAccess ? <CargasMonterrey/> : <Navigate to="/" />}
                        />
                        {/* Agregar Carga Fuel Up V2 */}
                        <Route 
                            path='/diesel/fuel_up/v2/agregar' 
                            element={canAccess ? <AgregarColombia/> : <Navigate to="/" />}
                        />
                        {/* Cargas Arguindegui */}
                        <Route 
                            path='/diesel/CargasArguin' 
                            element={canAccess ? <CargasArguin/> : <Navigate to="/" />}
                        />
                        {/* Cargas Loves */}
                        <Route 
                            path='/diesel/CargasLoves' 
                            element={canAccess ? <CargasLoves/> : <Navigate to="/" />}
                        />
                        {/* Cargas Oxxo */}
                        <Route 
                            path='/diesel/CargasOxxo' 
                            element={canAccess ? <CargasOxxo/> : <Navigate to="/" />}
                        />
                        <Route 
                            path='/diesel/kpi/dashboard' 
                            element={canAccess ? <Kpi/> : <Navigate to="/"/> }
                        />

                        <Route 
                            path='/diesel/kpi/driver' 
                            element={canAccess ? <KpiDriver/> : <Navigate to="/"/> }
                        />

                        <Route 
                            path='/diesel/kpi/asset' 
                            element={canAccess ? <KpiAsset/> : <Navigate to="/"/> }
                        />

                        <Route 
                            path='/diesel/kpi/idle' 
                            element={canAccess ? <KpiIdle/> : <Navigate to="/"/> }
                        />

                        {/* EBT DAILY FUEL PRICE */}
                        <Route
                            path="/diesel/daily-fuel-price"
                            element={
                                canAccess
                                    ? <DailyFuelPrice />
                                    : <Navigate to="/" />
                            }
                        />

                        {/* KPI DASHBOARD TANKS */}
                        <Route
                            path="/diesel/tanks"
                            element={
                                canAccess
                                    ? <TankDashboard />
                                    : <Navigate to="/" />
                            }
                        />

                        {/* Cargas GasoMax */}
                        <Route 
                            path='/diesel/CargasGasoMax' 
                            element={canAccess ? <CargasGasoMax/> : <Navigate to="/" />}
                        />

                        {/* Cargas DEF */}
                        <Route
                            path="/diesel/cargas/def"
                            element={
                                canAccess
                                    ? <DefCargas />
                                    : <Navigate to="/" />
                            }
                        />

                        {/* Compras Diesel */}
                        <Route 
                            path='/diesel/compras' 
                            element={canAccess ? <ComprasDiesel/> : <Navigate to="/" />}
                        />

                        {/* Compras DEF */}
                        <Route 
                            path='/diesel/compras/def' 
                            element={canAccess ? <ComprasDef/> : <Navigate to="/" />}
                        />

                        {/* FUEL AMERICA */}
                        <Route
                            path="/diesel/CargasFuelAmerica"
                            element={canAccess ? <CargasFuelAmerica /> : <Navigate to="/" />}
                        />

                        <Route
                            path="/diesel/samsara/rendimiento"
                            element={
                                canAccess
                                    ? <SamsaraRendimiento />
                                    : <Navigate to="/" />
                            }
                        />

                        <Route
                            path="/diesel/samsara/resets"
                            element={
                                canAccess
                                    ? <SamsaraResets />
                                    : <Navigate to="/" />
                            }
                        />

                        <Route
                            path="/diesel/mcleod/fsc-prueba"
                            element={canAccess ? <FscPrueba /> : <Navigate to="/" />}
                        />


                    </Routes>

                </div>

            </div>

        </div>

    )

}

export default Main